export default function () {
    const DISMISS_ENDPOINT = '/api/account-popup/dismiss';

    const getCsrfToken = () => {
        const meta = document.querySelector('meta[name="account-popup-csrf"]');
        return meta ? meta.getAttribute('content') : null;
    };

    const init = () => {
        const popup = document.querySelector('.account-popup');
        if (!popup) {
            return;
        }

        popup.classList.add('account-popup--visible');

        const dismissInput = popup.querySelector('[data-account-popup-dismiss]');

        const sendDismiss = () => {
            if (!dismissInput || !dismissInput.checked) {
                return;
            }
            const csrfToken = getCsrfToken();
            if (!csrfToken) {
                console.warn('[accountPopup] CSRF token meta missing — skipping dismiss request');
                return;
            }
            fetch(DISMISS_ENDPOINT, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': csrfToken,
                },
            }).catch((err) => {
                console.warn('[accountPopup] dismiss request failed', err);
            });
        };

        const close = () => {
            sendDismiss();
            popup.classList.remove('account-popup--visible');
        };

        const overlay = popup.querySelector('[data-account-popup-overlay]');
        if (overlay) {
            overlay.addEventListener('click', close);
        }

        popup.querySelectorAll('.account-popup__close').forEach((button) => {
            button.addEventListener('click', close);
        });

        // CTA with href: send dismiss before navigating away
        popup.querySelectorAll('a[data-account-popup-cta]').forEach((link) => {
            link.addEventListener('click', () => {
                sendDismiss();
            });
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && popup.classList.contains('account-popup--visible')) {
                close();
            }
        });

        // Swipe-down to close bottom-sheet on mobile
        if (popup.classList.contains('account-popup--mobile-bottom-sheet')) {
            const dialog = popup.querySelector('.account-popup__dialog');
            if (dialog) {
                let startY = null;
                dialog.addEventListener('touchstart', (event) => {
                    startY = event.touches[0].clientY;
                }, { passive: true });
                dialog.addEventListener('touchend', (event) => {
                    if (startY === null) return;
                    const deltaY = event.changedTouches[0].clientY - startY;
                    if (deltaY > 80) close();
                    startY = null;
                }, { passive: true });
            }
        }
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
}
